import { render, staticRenderFns } from "./JLTExam.vue?vue&type=template&id=4f2db424&"
import script from "./JLTExam.vue?vue&type=script&lang=js&"
export * from "./JLTExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports